// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__2DVCW","checkboxCol":"Table_checkboxCol__2CEQ6","emailCol":"Table_emailCol__1e2bG","actionCol":"Table_actionCol__zp1_c"};